module.exports = __webpack_public_path__ + "resources/warning-d0632c5b4cd685788fa9afedfc468c0f.svg";